
<template>
  <div class="btn-know ft-16"
    :class="{ dark }"
    @click="btnClick">{{$t('btn1')}}</div>
</template>

<script>
export default {
  props: {
    dark: Boolean
  },

  methods: {
    btnClick () {
      this.$emit('btnclick')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-know {
  cursor: pointer;
  width: 134px;
  height: 40px;
  font-size: 14px;
  border-width: 1px;
  border-style: solid;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-color: #fff;
  // background-color: #000;
  transition: color 0.4s cubic-bezier(.77,.15,0,.99),
    border-color 0.4s cubic-bezier(.77,.15,0,.99),
    background-color 0.4s cubic-bezier(.77,.15,0,.99);
}

.btn-know.dark {
  color: #000;
  border-color: #000;
  transition: color 0.4s cubic-bezier(.77,.15,0,.99),
    border-color 0.4s cubic-bezier(.77,.15,0,.99),
    background-color 0.4s cubic-bezier(.77,.15,0,.99);
}

.btn-know:hover {
  color: #000;
  border-color: #000;
  background-color: #fff;
}

.btn-know.dark:hover {
  color: #fff;
  border-color: #fff;
  background-color: #000;
}
</style>
